export default __webpack_public_path__ + "static/media/q30_v2.a9b62773.png";